import { Group } from '@studio/design-system/toggle/group';
import { useLatestFn } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import { Item } from './item.jsx';
import type { Props } from './types.js';
import { toArrangement } from '#~/video/index.js';
import { useAnalytics, EVENT_CATEGORIES, EVENT_NAMES } from '#~/analytics/index.js';

/** `<Arrangement>` component. */
export const Arrangement = ({ available, selection, ...props }: Props): ReactElement => {
  const { track } = useAnalytics();

  const handleValueChange = useLatestFn((value: string) => {
    const nextValue = toArrangement(value);

    if (nextValue) {
      selection.setValue(nextValue);
      track(EVENT_NAMES.SELECT_VIEW_TYPE, EVENT_CATEGORIES.VIEW, {
        arrangement: nextValue
      });
    }
  });

  return (
    <div {...props}>
      <Group
        className='gap-4 bg-unset'
        onValueChange={handleValueChange}
        type='single'
        value={selection.value}
      >
        {available.map(({ arrangement, disabled }) => (
          <Item disabled={disabled} key={arrangement} value={arrangement} />
        ))}
      </Group>
    </div>
  );
};
